import { render, staticRenderFns } from "./SectionCta.vue?vue&type=template&id=2516d79a&"
import script from "./SectionCta.vue?vue&type=script&lang=js&"
export * from "./SectionCta.vue?vue&type=script&lang=js&"
import style0 from "./SectionCta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResponsiveImageStrapi: require('/home/northbankcm/public_html/frontend/components/modules/ResponsiveImageStrapi.vue').default})
